const COLORS = [
  "#4F46E5",
  "#0891B2",
  "#059669",
  "#D97706",
  "#DC2626",
  "#7C3AED",
  "#DB2777",
];

const getInitials = (name) => {
  if (!name) return "?";
  const parts = name.trim().split(/\s+/);
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[1][0]).toUpperCase();
};

const getColor = (name) => {
  if (!name) return "#6B7280";
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }
  return COLORS[Math.abs(hash) % COLORS.length];
};

const UserAvatar = ({ name, size = 40, fontSize = 14 }) => (
  <div
    style={{
      width: size,
      height: size,
      borderRadius: "50%",
      background: getColor(name),
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: "#fff",
      fontWeight: 600,
      fontSize,
      flexShrink: 0,
      userSelect: "none",
    }}
  >
    {getInitials(name)}
  </div>
);

export default UserAvatar;
